import getAccountProperties from './getAccountProperties'

export default function getAccountEmail() {
  const { email } = getAccountProperties()

  return email
}
